import React from 'react';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Chip } from '../Chip/Chip.es.js';
import { ChipGroup as ChipGroup$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSingleSelectChip = (_a) => {
  var _b = _a, {
    isChecked,
    onChange,
    name,
    value,
    groupValue,
    isDisabled,
    isLoading,
    isError,
    isChipsFillGroupWidth,
    direction,
    gutter
  } = _b, props = __objRest(_b, [
    "isChecked",
    "onChange",
    "name",
    "value",
    "groupValue",
    "isDisabled",
    "isLoading",
    "isError",
    "isChipsFillGroupWidth",
    "direction",
    "gutter"
  ]);
  const handleChange = () => {
    if (isError || isDisabled || isLoading) {
      return;
    }
    onChange([value]);
  };
  return /* @__PURE__ */ React.createElement(Chip, __spreadProps(__spreadValues({}, props), {
    isChecked: groupValue.includes(value),
    isDisabled,
    isError,
    isLoading,
    onClick: handleChange
  }));
};
const StyledMultipleSelectChip = (_c) => {
  var _d = _c, {
    groupValue,
    isChecked,
    isDisabled,
    isError,
    isLoading,
    name,
    onChange,
    isChipsFillGroupWidth,
    direction,
    gutter,
    value
  } = _d, props = __objRest(_d, [
    "groupValue",
    "isChecked",
    "isDisabled",
    "isError",
    "isLoading",
    "name",
    "onChange",
    "isChipsFillGroupWidth",
    "direction",
    "gutter",
    "value"
  ]);
  const newGroupValue = [];
  const handleChange = () => {
    if (isDisabled || isError) {
      return;
    }
    const inputs = groupValue.slice();
    for (const i in inputs) {
      if (!newGroupValue.includes(inputs[i]) && inputs[i] !== value) {
        newGroupValue.push(inputs[i]);
        if (!groupValue.includes(value) && !newGroupValue.includes(value)) {
          newGroupValue.push(value);
        }
      }
    }
    if (!inputs.length) {
      newGroupValue.push(value);
    }
    groupValue = newGroupValue;
    onChange(groupValue);
  };
  return /* @__PURE__ */ React.createElement(Chip, __spreadProps(__spreadValues({}, props), {
    isDisabled,
    isError,
    isLoading,
    isChecked: groupValue.includes(value),
    onClick: handleChange
  }));
};
const Item = (_e) => {
  var _f = _e, {
    onChange,
    groupValue,
    value,
    name,
    isMultiSelect,
    isDisabled,
    isError,
    isLoading,
    isChecked,
    tooltipProps,
    isChipsFillGroupWidth,
    direction,
    gutter
  } = _f, props = __objRest(_f, [
    "onChange",
    "groupValue",
    "value",
    "name",
    "isMultiSelect",
    "isDisabled",
    "isError",
    "isLoading",
    "isChecked",
    "tooltipProps",
    "isChipsFillGroupWidth",
    "direction",
    "gutter"
  ]);
  const commonProps = {
    name,
    groupValue,
    value,
    onChange,
    isChecked,
    isDisabled,
    isError,
    isLoading,
    tooltipProps,
    isChipsFillGroupWidth,
    direction,
    gutter
  };
  return isMultiSelect ? /* @__PURE__ */ React.createElement(StyledMultipleSelectChip, __spreadValues(__spreadValues({}, commonProps), props)) : /* @__PURE__ */ React.createElement(StyledSingleSelectChip, __spreadValues(__spreadValues({}, commonProps), props));
};
const StyledChipGroup = (_g) => {
  var _h = _g, {
    shape,
    size,
    isMultiSelect,
    value,
    kind,
    isInvertedCheckedKind,
    onChange,
    isChipsFillGroupWidth,
    direction = "horizontal",
    gutter = "xxs",
    children
  } = _h, props = __objRest(_h, [
    "shape",
    "size",
    "isMultiSelect",
    "value",
    "kind",
    "isInvertedCheckedKind",
    "onChange",
    "isChipsFillGroupWidth",
    "direction",
    "gutter",
    "children"
  ]);
  return /* @__PURE__ */ React.createElement(ChipGroup$1, __spreadValues({
    isChipsFillGroupWidth,
    direction,
    gutter
  }, props), React.Children.map(children, (item) => React.cloneElement(item, {
    size,
    shape,
    kind,
    isInvertedCheckedKind,
    isDisabled: item.props.isDisabled,
    isChecked: item.props.isChecked,
    isLoading: item.props.isLoading,
    isError: item.props.isError,
    groupValue: value,
    onChange,
    isMultiSelect,
    isChipsFillGroupWidth,
    direction,
    gutter
  })));
};
const compoundComponents = {
  Item
};
const ChipGroup = maestroComponent("ChipGroup", StyledChipGroup, compoundComponents);

export { ChipGroup };
//# sourceMappingURL=ChipGroup.es.js.map
